"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _base = _interopRequireDefault(require("./base"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The Export service
 */
var Export = /*#__PURE__*/function (_Base) {
  /**
   * Create the export service instance.
   *
   * @param sdk - the SDK instance
   */
  function Export(sdk) {
    (0, _classCallCheck2["default"])(this, Export);
    return _callSuper(this, Export, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Export, _Base);
  return (0, _createClass2["default"])(Export, [{
    key: "exportSheets",
    value: (
    /**
     * Create export sheets job.
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/3a733c371516f-create-sheets-export-job
     *
     * @param projectId - is the project id
     * @param payload -, include 2 properties:
     *  \{
     *    sheets:[],                array, the sheets id for exporting
     *    options: \{
     *      includePublicMarkups,   boolean, default: true
     *      includePrivateMarkups,  boolean, default: true
     *      includeMarkupLinks,     boolean, default: false
     *      includeAutomaticHyperlinks,     boolean, default: false
     *      includePublicIssueMarkups,      boolean, default: false
     *      includeUnpublishedIssueMarkups,      boolean, default: false
     *      skipActivity,           boolean, default: false
     *      outputFileName,         string, the exported file name
     *      outputType,             string, default: pdf, and only support pdf now
     *      locale,                 string, default: en, should be one of [cs, da, de, en-GB, en, es, fr-CA, fr, it, ja, nl, no, sv, zh-Hans, zh-Hant]
     *    \}
     *  \}
     *
     * @param config - Configurable object for overwrite request parameters
     * @returns a promise with job id, shape of \{ jobId: string \}
     */
    function () {
      var _exportSheets = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/sheets:export");
              _context.next = 3;
              return this.HttpService.exportV1.post(url, payload, config);
            case 3:
              res = _context.sent;
              return _context.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function exportSheets(_x, _x2, _x3) {
        return _exportSheets.apply(this, arguments);
      }
      return exportSheets;
    }()
    /**
     * Create export files job.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/c13465642b68f-create-files-export-job
     *
     * @param projectId - is the project id
     * @param payload -, include 2 properties:
     *  \{
     *    documents:[],                 array[string], the version urn array for exporting
     *    options: \{
     *      type,                       string, the exporting markup type, enum: markups, progressTracking
     *      skipActivity,               boolean, if to skip sending activity, default: false
     *      outputFileName,             string, the exported file name
     *      outputType,                 string, default: pdf, and only support pdf now, enum: pdf, zip
     *      standardMarkups: \{          only work if the type is 'markups'
     *        includePublicMarkups,     boolean, default: true
     *        includePrivateMarkups,    boolean, default: true
     *        includeMarkupLinks,       boolean, default: false
     *      \},
     *      issueMarkups: \{              only work if the type is 'markups'
     *        includePublicMarkups,      boolean, default: false
     *        includeUnpublishedMarkups, boolean, default: false
     *        includeRelatedIssues,      boolean, default: false
     *      \},
     *      photoMarkups: \{              only work if the type is 'markups'
     *        includePublicMarkups,      boolean, default: false
     *        includePrivateMarkups,     boolean, default: false
     *      \},
     *      locale,                      string, default: en, should be one of [cs, da, de, en-GB, en, es, fr-CA, fr, it, ja, nl, no, sv, zh-Hans, zh-Hant]
     *    \}
     *  \}
     * @param config - Configurable object for overwrite request parameters
     * @returns a promise with job id, shape of \{ jobId: string \}
     */
    )
  }, {
    key: "exportFiles",
    value: (function () {
      var _exportFiles = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              url = "/projects/".concat(projectId, "/files:export");
              _context2.next = 3;
              return this.HttpService.exportV2.post(url, payload, config);
            case 3:
              res = _context2.sent;
              return _context2.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function exportFiles(_x4, _x5, _x6) {
        return _exportFiles.apply(this, arguments);
      }
      return exportFiles;
    }()
    /**
     * Create export files job from review.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/0ca852f54f00d-create-a-project-review-files-export
     *
     * @param projectId - is the project id
     * @param reviewId -, is the review id
     * @param payload -, include 2 properties:
     *  \{
     *    documents:[],                 array[string], the version urn array for exporting
     *    options: \{
     *      type,                       string, the exporting markup type, enum: markups, progressTracking(only markups support now)
     *      outputFileName,             string, the exported file name
     *      outputType,                 string, default: pdf, and only support pdf now, enum: pdf, zip
     *      standardMarkups: \{          only work if the type is 'markups'
     *        includePublicMarkups,     boolean, default: true
     *        includePrivateMarkups,    boolean, default: true
     *        includeMarkupLinks,       boolean, default: false
     *      \},
     *      issueMarkups: \{              only work if the type is 'markups'
     *        includePublicMarkups,      boolean, default: false
     *        includeUnpublishedMarkups, boolean, default: false
     *      \},
     *      photoMarkups: \{              only work if the type is 'markups'
     *        includePublicMarkups,      boolean, default: false
     *        includePrivateMarkups,     boolean, default: false
     *      \},
     *      locale,                      string, default: en, should be one of [cs, da, de, en-GB, en, es, fr-CA, fr, it, ja, nl, no, sv, zh-Hans, zh-Hant]
     *    \}
     *  \}
     * @param config - Configurable object for overwrite request parameters
     * @returns a promise with job id, shape of \{ jobId: string \}
     */
    )
  }, {
    key: "exportFilesFromReview",
    value: (function () {
      var _exportFilesFromReview = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, reviewId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              url = "/projects/".concat(projectId, "/reviews/").concat(reviewId, "/files:export");
              _context3.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context3.sent;
              return _context3.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function exportFilesFromReview(_x7, _x8, _x9, _x10) {
        return _exportFilesFromReview.apply(this, arguments);
      }
      return exportFilesFromReview;
    }()
    /**
     * Get export job status(for sheets).
     * https://platform.stoplight.autodesk.com/docs/docs-sheets/b418174a3072b-get-export-job
     *
     * @param projectId - is the project id
     * @param jobId -  the job id for exporting.
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with job status, shape of
     *                    \{
     *                      status: string, could be one of ["successful", "processing", "failed"]
     *                      result: object, not returns if status is "processing"
     *                        \{
     *                          output: object, not returns if status is "failed"
     *                            \{
     *                              signedUrl: string,
     *                            \}
     *                          error: object, not returns if status is "successfully"
     *                            \{
     *                               \{ code: string, title: string, detail: string \}
     *                            \}
     *                        \}
     *                    \}
     */
    )
  }, {
    key: "getJobStatus",
    value: (function () {
      var _getJobStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, jobId, config) {
        var res;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.HttpService.exportV1.get("/projects/".concat(projectId, "/jobs/").concat(jobId), config);
            case 2:
              res = _context4.sent;
              return _context4.abrupt("return", res.data || {});
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getJobStatus(_x11, _x12, _x13) {
        return _getJobStatus.apply(this, arguments);
      }
      return getJobStatus;
    }()
    /**
     * Get export job status v2(for files).
     * https://platform.stoplight.autodesk.com/docs/docs-cp/bc55b2c1e19dd-get-export-job
     *
     * @param projectId - is the project id
     * @param jobId -  the job id for exporting.
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with job status, shape of
     *                    \{
     *                      status: string, could be one of ["successful", "processing", "failed"]
     *                      result: object, not returns if status is "processing"
     *                        \{
     *                          output: object, not returns if status is "failed"
     *                            \{
     *                              signedUrl: string,
     *                            \}
     *                          error: object, not returns if status is "successfully"
     *                            \{
     *                               \{ code: string, title: string, detail: string \}
     *                            \}
     *                        \}
     *                    \}
     */
    )
  }, {
    key: "getJobStatusV2",
    value: (function () {
      var _getJobStatusV = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, jobId, config) {
        var res;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.HttpService.exportV2.get("/projects/".concat(projectId, "/jobs/").concat(jobId), config);
            case 2:
              res = _context5.sent;
              return _context5.abrupt("return", res.data || {});
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getJobStatusV2(_x14, _x15, _x16) {
        return _getJobStatusV.apply(this, arguments);
      }
      return getJobStatusV2;
    }()
    /**
     * Create export job for publicly shared sheets.
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Sheet%20share%20link.oas2.yml?view=%2Fshare-link%2Fexportsheetssharelink
     *
     * @param projectId - is the project id
     * @param payload -, include 3 properties:
     *  \{
     *    linkIds:[],                array, the links ids for exporting
     *    outputFileName,            string, the exported file name(do not include the extension)
     *    recipientId                string, the id of recipient
     *  \}
     * @param config - Configurable object for overwrite request parameters
     * @returns a promise with job id, shape of \{ jobId: string \}
     */
    )
  }, {
    key: "exportSharedSheets",
    value: (function () {
      var _exportSharedSheets = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              url = "/projects/".concat(projectId, "/sheets/shared/resources/export");
              _context6.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context6.sent;
              return _context6.abrupt("return", res.data || {});
            case 5:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function exportSharedSheets(_x17, _x18, _x19) {
        return _exportSharedSheets.apply(this, arguments);
      }
      return exportSharedSheets;
    }()
    /**
     * Get export job status for publicly shared sheets.
     * https://stoplight.autodesk.com/acs/acs-docs/version%2F1.1/Sheet%20share%20link.oas2.yml?view=%2Fshare-link%2Fgetexportjob
     *
     * @param projectId - is the project id
     * @param jobId -  the job id for exporting.
     * @param config - Configurable object for overwrite request parameters.
     * @returns a promise with job status, shape of
     *                    \{
     *                      status: string, could be one of ["successful", "processing", "failed"]
     *                      result: object, not returns if status is "processing"
     *                        \{
     *                          output: object, not returns if status is "failed"
     *                            \{
     *                              signedUrl: string,
     *                            \}
     *                          error: object, not returns if status is "successfully"
     *                            \{
     *                               \{ code: string, title: string, detail: string \}
     *                            \}
     *                        \}
     *                    \}
     */
    )
  }, {
    key: "getSharedJobStatus",
    value: (function () {
      var _getSharedJobStatus = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(projectId, jobId, config) {
        var res;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.HttpService.dmV3.get("/projects/".concat(projectId, "/sheets/shared/export-jobs/").concat(jobId), config);
            case 2:
              res = _context7.sent;
              return _context7.abrupt("return", res.data || {});
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getSharedJobStatus(_x20, _x21, _x22) {
        return _getSharedJobStatus.apply(this, arguments);
      }
      return getSharedJobStatus;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Export';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Export;